<div id="findbarOptionsTwoContainer">
  <pdf-find-entire-word></pdf-find-entire-word>
  <pdf-find-entire-phrase></pdf-find-entire-phrase>
</div>
